import { Link, useNavigate } from 'react-router-dom'
import CLUB from '../config/club.js'

// Small back/home button cluster anchored top-left of a page. Used by every
// non-home screen so users can always escape. Style is intentionally muted —
// dark translucent pill with gold text — so it doesn't compete with the
// content (especially the leaderboard TV display).
//
// Props:
//   back:     boolean — show ← Back (uses history.back, falls back to /)
//   home:     boolean (default true) — show 🏠 Home. Pass home={false} on
//             player-facing scorecard-QR screens (scorecard, hub, photos) so
//             players are never sent to the home/landing screen.
//   absolute: boolean (default true) — position fixed top-left vs inline
//   tone:     'gold' | 'light' (default 'gold') — pick contrast for bg
export default function PageNav({ back = false, home = true, absolute = true, tone = 'gold', homeTo = '/' }) {
  const navigate = useNavigate()

  const wrapperClass = absolute
    ? 'absolute top-3 left-3 flex gap-2 z-30'
    : 'inline-flex gap-2'

  const goldStyle = {
    backgroundColor: 'rgba(0,0,0,0.55)',
    color: CLUB.accentColor,
    border: `1px solid ${CLUB.accentColor}66`,
  }
  const lightStyle = {
    backgroundColor: 'rgba(255,255,255,0.10)',
    color: '#FFFFFF',
    border: '1px solid rgba(255,255,255,0.40)',
  }
  const btnStyle = tone === 'light' ? lightStyle : goldStyle
  const btnClass = 'rounded-lg px-2.5 py-1.5 text-[11px] font-extrabold uppercase tracking-wider transition active:scale-95 whitespace-nowrap'

  const onBack = () => {
    if (window.history.length > 1) navigate(-1)
    else navigate('/', { replace: true })
  }

  return (
    <div className={wrapperClass}>
      {back ? (
        <button onClick={onBack} className={btnClass} style={btnStyle}>← Back</button>
      ) : null}
      {home ? (
        <Link to={homeTo} className={btnClass} style={btnStyle}>🏠 Home</Link>
      ) : null}
    </div>
  )
}
